import { createTrackingUtils } from "../index";
import useLocaleContext from "hooks/useLocaleContext";

const utils = createTrackingUtils({
  name: "flights_web_filters_width_desktop",
  stages: {
    desktop_sr: 1,
    ltr: 2,
    rtl: 3
  },
  defaultStage: 1,
  goals: {}
});

export const useTrackReducedFiltersWidth = () => {
  const { stages } = utils;
  const { locale } = useLocaleContext();

  locale?.isRTL ? stages.rtl() : stages.ltr();
};

export default utils;
